/**
 * Theme color utility functions for random color generation
 */

/**
 * Generate a random hex color with good saturation and lightness
 */
function generateRandomHexColor(): string {
  const h = Math.floor(Math.random() * 360);
  const s = Math.floor(Math.random() * 40) + 50; // 50-90% saturation
  const l = Math.floor(Math.random() * 30) + 35; // 35-65% lightness

  // Convert HSL to hex
  const sDecimal = s / 100;
  const lDecimal = l / 100;
  const c = (1 - Math.abs(2 * lDecimal - 1)) * sDecimal;
  const x = c * (1 - Math.abs(((h / 60) % 2) - 1));
  const m = lDecimal - c / 2;
  let r = 0,
    g = 0,
    b = 0;

  if (h >= 0 && h < 60) {
    r = c;
    g = x;
    b = 0;
  } else if (h >= 60 && h < 120) {
    r = x;
    g = c;
    b = 0;
  } else if (h >= 120 && h < 180) {
    r = 0;
    g = c;
    b = x;
  } else if (h >= 180 && h < 240) {
    r = 0;
    g = x;
    b = c;
  } else if (h >= 240 && h < 300) {
    r = x;
    g = 0;
    b = c;
  } else {
    r = c;
    g = 0;
    b = x;
  }

  const toHex = (n: number) => {
    const hex = Math.round((n + m) * 255).toString(16);
    return hex.length === 1 ? "0" + hex : hex;
  };

  return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
}

/**
 * Generate 4 random preview colors for theme thumbnails
 */
function generateRandomPreviewColors(): string[] {
  return [
    generateRandomHexColor(),
    generateRandomHexColor(),
    generateRandomHexColor(),
    generateRandomHexColor(),
  ];
}

export { generateRandomHexColor, generateRandomPreviewColors };
